import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { commodityList, getCommodityVariertyList, getContractStage, getContractType, getDestinationByType, getSelectedContractDetail, InternalDestinationList } from "../../../modules/contract/action";
import { getCounterpartList, getLoadNumberIndicatorList, getOriginType, updateTicket } from "../../../modules/ticket/action";
import { trucklineListAction } from "../../../modules/truckline/action";
import "../../../style";
import TicketForm from "./TicketForm";






const defaultDestinationTypeId = "2";

class EditTicket extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ticketInfo: {
        farmId: this.props.SubFarmId
          ? this.props.SubFarmId
          : userFarmDetail().id || this.props.MainFarmId,
        primaryContractNumber: "",
        ticketNumber: "",
        counterpartId: "",
        type: "",
        originTypeId: "",
        loadDate: "",
        commodityId: "",
        commodityVarietyId: "",
        destinationTypeId: defaultDestinationTypeId,
        destinationId: "",
        trucklineId: "",
        truckNumber: "",
        trailerNumber: "",
        driverName: "",
        loadNumberIndicatorId: "",
        loadNumber: "",
        scaleTicketNumber: "",
        billOfLading: "",
        fieldEstimatedLoadWeight: "",
        fieldEstimatedLoadBushels: 0,
        fieldsEstimatedMoisture: "",
        shrinkMultiplier: "",
        estimatedHomeScaleShrinkBushels: 0,
        homeScaleEstimatedMoisture: "",
        homeScaleWeightFilled: "",
        homeScaleWeightEmpty: "",
        primarySourceId: "",
        secondarySourceId: "",
        loadCost: 0
      },
      successMessage: "",
      isValid: true,
      mandatoryFields: {
        1: [
          "loadDate",
          "commodityId",
          "commodityVarietyId",
          "originTypeId",
          "primarySourceId",
          "destinationId",
          "loadNumberIndicatorId"
        ],
        2: [
          "primaryContractNumber",
          "counterpartId",
          "loadDate",
          "commodityId",
          "commodityVarietyId",
          "originTypeId",
          "primarySourceId",
          "destinationId",
          "loadNumberIndicatorId"
        ]
      }
    };
  }

  componentWillMount() {
    const { EditTicket } = this.props;
    if (!EditTicket) {
      this.props.route.history.push("/app");
    } else {
      let date = new Date(EditTicket.loadDate);
      date = moment(EditTicket.loadDate).format("MM/DD/YYYY");

      this.setState({
        ticketInfo: {
          createdBy: EditTicket.createdBy,
          updatedBy: EditTicket.updatedBy,
          createdAt: EditTicket.createdAt,
          updatedAt: EditTicket.updatedAt,
          farmId: this.props.SubFarmId
            ? this.props.SubFarmId
            : userFarmDetail().id || this.props.MainFarmId,
          primaryContractNumber: EditTicket.primaryContractNumber
            ? EditTicket.primaryContractNumber.contractNumber
            : "",
          ticketNumber: EditTicket.ticketNumber,
          counterpartId:
            EditTicket.counterpartResponseDTO &&
            EditTicket.counterpartResponseDTO.id,
          type: EditTicket.type ? EditTicket.type : 1,
          originTypeId:
            EditTicket.originType && EditTicket.originType.id.toString(),
          loadDate: EditTicket.loadDate,
          commodityId:
            EditTicket.commodityResponseDTO &&
            EditTicket.commodityResponseDTO.id,
          commodityVarietyId:
            EditTicket.commodityVarietyResponseDTO &&
            EditTicket.commodityVarietyResponseDTO.id,
          destinationTypeId:
            EditTicket.destinationResponseDTO &&
            EditTicket.destinationResponseDTO.destinationTypeDTO.id.toString(),
          destinationId:
            EditTicket.destinationResponseDTO &&
            EditTicket.destinationResponseDTO.id,
          trucklineId: EditTicket.truckline && EditTicket.truckline.id,
          truckNumber: EditTicket.truckNumber,
          trailerNumber: EditTicket.trailerNumber,
          driverName: EditTicket.driverName,
          loadNumberIndicatorId:
            EditTicket.loadNumberIndicatorResponseDto &&
            EditTicket.loadNumberIndicatorResponseDto.id,
          loadNumber: EditTicket.loadNumber,
          scaleTicketNumber: EditTicket.scaleTicketNumber,
          billOfLading: EditTicket.billOfLading,
          fieldEstimatedLoadWeight: EditTicket.fieldEstimatedLoadWeight,
          fieldEstimatedLoadBushels: EditTicket.fieldEstimatedLoadBushels,
          fieldsEstimatedMoisture: EditTicket.fieldsEstimatedMoisture,
          shrinkMultiplier: EditTicket.shrinkMultiplier,
          estimatedHomeScaleShrinkBushels:
            EditTicket.estimatedHomeScaleShrinkBushels,
          homeScaleEstimatedMoisture: EditTicket.homeScaleEstimatedMoisture,
          homeScaleWeightFilled: EditTicket.homeScaleWeightFilled,
          homeScaleWeightEmpty: EditTicket.homeScaleWeightEmpty,
          comments: EditTicket.comments,
          primarySourceId: EditTicket.primarySource.id,
          secondarySourceId: EditTicket.secondarySource
            ? EditTicket.secondarySource.id
            : null,
          loadCost: EditTicket.loadCost,
          secondaryFieldSplit: EditTicket.secondaryFieldSplit
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.TicketUpdated && nextProps.TicketUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  getLoadNumberFromIndicator = id => {
    const { LoadNumberIndicatorList } = this.props;
    const timestamp = Date.now();
    const numberObject = LoadNumberIndicatorList.filter(
      value => value.id === id
    );
    let varCode = numberObject ? numberObject[0].code : "";
    this.setState(prevState => {
      return {
        ticketInfo: {
          ...prevState.ticketInfo,
          ["loadNumber"]: `${varCode}_${timestamp}`
        }
      };
    });
  };

  updateTicket = ticketInfo => {
    // const { ticketInfo } = this.state;
    this.setState({
      isValid: true
    });
    this.props.actions.updateTicket(ticketInfo);
  };

  checkValidation = ticketInfo => {
    const { mandatoryFields } = this.state;
    //   if(mandatoryFields[1] && ticketInfo.trucklineId) {
    //     mandatoryFields[1].push("truckNumber");
    //     mandatoryFields[1].push("driverName");
    //     console.log
    // }
    console.log(ticketInfo);
    this.setState({
      isValid: false
    });
    console.log(this.state.isValid);
  };

  render() {
    const { ticketInfo, successMessage, isValid } = this.state;
    console.log(ticketInfo, "kkkk");
    if (successMessage) {
      return <Redirect to="/app/tickets" />;
    }

    return (
      <TicketForm
        formLabel="Edit Ticket"
        buttonLabel="Update"
        ticketInfo={ticketInfo}
        changeFunction={this.handleChange}
        submitFunction={this.updateTicket}
        isValid={isValid}
        checkValidation={this.checkValidation}
        editMode={true}
      />
    );
  }
}
function mapStateToProps(state) {
  return {
    EditTicket: state.ticketReducer.EditSelectedTicket,
    TicketUpdated: state.ticketReducer.TicketUpdated,
    commodityList: state.contractReducer.commodityList,
    commodityVarietyList: state.contractReducer.commodityVarietyList,
    LoadNumberIndicatorList: state.ticketReducer.LoadNumberIndicatorList,
    selectedContractDetails: state.contractReducer.selectedContractDetails,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        commodityList,
        getCommodityVariertyList,
        getCounterpartList,
        getContractStage,
        getContractType,
        getOriginType,
        getDestinationByType,
        getLoadNumberIndicatorList,
        updateTicket,
        InternalDestinationList,
        trucklineListAction,
        getSelectedContractDetail
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditTicket);



// WEBPACK FOOTER //
// ./src/components/private/Tickets/EditTicket.js